var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"g-timeaxis"}},[_c('div',{staticClass:"g-timeaxis-empty-space",style:({width: _vm.rowLabelWidth, background: _vm.themeColors.secondary})}),_c('div',{staticClass:"g-timeaxis-days",style:({width: `${100-_vm.rowLabelWidth.replace('%','')}%`})},_vm._l((_vm.axisDays),function(day,index){return _c('div',{key:day.text,staticClass:"g-timeaxis-day",style:({
        width: day.widthPercentage+'%', 
        background: index%2===0 ? _vm.themeColors.primary : _vm.themeColors.secondary,
        color: _vm.themeColors.text
      })},[_c('div',[_vm._v(_vm._s(_vm.dayFormatted(day))+" ")])])}),0),_c('div',{attrs:{"id":"g-timeaxis-marker"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }